"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { Button } from "react-vant";
import hottestDealsApi from "@/service/modules/hottestDealsApi";
import type { ProductType } from "@/types/product";
import { normalizeLegacySiteUrl } from "@/utils/legacySiteUrl";
import styles from "@/styles/hottest-deals/hot-schema.module.scss";

interface HotSchemaItem {
  itemID: number;
  name: string;
  title: string;
  extraTitle: string;
  isEnable: number;
  url: string;
  logoUrl: string;
  items: ProductType[];
}

export default function HotSchema() {
  const [hotSchemaData, setHotSchemaData] = useState<HotSchemaItem[]>([]);

  // 获取Hot Scheme模块数据
  async function getHotSchemeData() {
    try {
      const resData = await hottestDealsApi.getHotScheme();

      if (resData.data && resData.data.length) {
        // 旧 API 可能仍返回 Crazysales 绝对链接，统一留在当前 BestDeals 环境。
        const formattedData = resData.data.map((item: HotSchemaItem) => ({
          ...item,
          url: normalizeLegacySiteUrl(item.url),
        }));
        setHotSchemaData(formattedData);
      }
    } catch (error) {
      console.log(`Hot Scheme模块数据获取失败：`, error);
    }
  }

  useEffect(() => {
    // 获取Hot Scheme模块数据
    getHotSchemeData();
  }, []);

  return (
    <>
      {hotSchemaData && hotSchemaData.length > 0 && (
        <div className={styles["comp-hot-schema"]}>
          <div className={styles["title"]}>Hot Deals</div>
          <div className={styles["scheme-list"]}>
            {
              hotSchemaData.map((item) => (
                <Link href={item.url} key={item.itemID}>
                  <div className={styles["scheme-item"]}>
                    <Image 
                      src={item.logoUrl} 
                      alt={item.name} 
                      width={350} 
                      height={115} 
                      style={{ width: '100%', height: 'auto' }}
                    />
                    <div className={styles["scheme-title"]}>
                      <div className={styles["scheme-name-wrapper"]}>
                        <span className={styles["scheme-name"]}>{item.name}</span>
                        {item.extraTitle && (
                          <span className={styles["scheme-extra-title"]}>{item.extraTitle}</span>
                        )}
                      </div>
                      <Button
                        size="small"
                        type="primary"
                        style={{ 
                          flexShrink: 0,
                          marginLeft: "8px"
                        }}
                      >
                        See More
                      </Button>
                    </div>
                  </div>
                </Link>
              ))
            }
          </div>
        </div>
      )}
    </>
  );
}
